import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

import { styled } from '@mui/material/styles';
import StarIcon from 'src/assets/images/icons/star.svg';
import ChartIcon from 'src/assets/images/icons/chart.svg';
import { useGetDomainMetaData } from 'src/use-cases/invoice/useInvoices';
import { InvoicesStatus, useNavigateToRnA } from 'src/presentations/components/pages/dashboardPage/hook/useNavigateToRnA';

const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiMenu-paper': {
    borderRadius: '8px!important',
    border: '1px solid #DFDFDF',
    background: '#FFF',
    boxShadow: '0px 12px 12px 0px rgba(34, 65, 102, 0.09)',
    width: '350px',
    [theme.breakpoints.down(1520)]: {
      width: '320px',
      '& .MuiListItemIcon-root': {
        width: '24px',
        height: '24px',
        minWidth: '32px',
      },
    },
  },
}));

interface IMoreItemsProps {
  moreActionEl: HTMLButtonElement | null;
  onCloseMoreAction: () => void;
  provider: string;
  modality: string;
}

export const MoreActionsMenu = ({ moreActionEl, onCloseMoreAction, provider, modality }: IMoreItemsProps) => {
  const { navigateToRnA, navigateToPerformance } = useNavigateToRnA({ modality, provider });
  const { data: dataStatus } = useGetDomainMetaData();
  const defaultCurrency = dataStatus?.defaultCurrency || null;

  return (
    <StyledMenu
      open={!!moreActionEl}
      anchorEl={moreActionEl}
      onClose={onCloseMoreAction}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      style={{ marginTop: '5px' }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <MenuItem onClick={() => navigateToPerformance(defaultCurrency)}>
        <ListItemIcon>
          <img src={StarIcon} alt='StarIcon' />
        </ListItemIcon>
        <ListItemText>
          <span className='text-14 xl:text-16'>Performance Assessment</span>
        </ListItemText>
      </MenuItem>

      <MenuItem onClick={() => navigateToRnA(InvoicesStatus.UNRESOLVED)}>
        <ListItemIcon>
          <img src={ChartIcon} alt='ChartIcon' />
        </ListItemIcon>
        <ListItemText>
          <span className='text-14 xl:text-16'>Reports & Analytics</span>
          <span className='ms-[8px] text-[#808080] text-12 xl:text-14'>Unresolved Invoices</span>
        </ListItemText>
      </MenuItem>

      <MenuItem onClick={() => navigateToRnA(InvoicesStatus.RESOLVED)}>
        <ListItemIcon>
          <img src={ChartIcon} alt='ChartIcon' />
        </ListItemIcon>
        <ListItemText>
          <span className='text-14 xl:text-16'>Reports & Analytics</span>
          <span className='ms-[8px] text-[#808080] text-12 xl:text-14'>Resolved Invoices</span>
        </ListItemText>
      </MenuItem>
    </StyledMenu>
  );
};
